export default __webpack_public_path__ + "assets/Fullstack_nithin_gudala_resume.16e34cdc.docx";